import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y, Autoplay, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/a11y";
import "swiper/css/autoplay";
import "swiper/css/navigation";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Category } from "../../types/home-page";
import { useState } from "react";
import Modal from "../modals/adahy-modal";

export default function CategoriesSection({
    categories,
}: {
    categories: Category[];
}) {
    const { i18n, t } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);

    const handleCategoryClick = (e: React.MouseEvent, categoryName: string) => {
        // if (
        //     categoryName.toLowerCase() === "eid qurbani" ||
        //     categoryName === "الأضاحي" ||
        //     categoryName.toLowerCase() === "udhyaa"
        //     // ||
        //     // categoryName.toLowerCase() === "eid udiha"
        // ) {
        //     e.preventDefault();
        //     setShowPopup(true);
        // }
    };
    return (
        <div>
            <h3 className="mb-2 text-2xl font-medium text-[rgba(23,23,23,1)] xl:mb-8 xl:text-[28px]">
                {t("categories")}
            </h3>
            <Swiper
                modules={[Navigation, A11y, Autoplay, Scrollbar]}
                slidesPerView={10}
                breakpoints={{
                    0: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    600: {
                        slidesPerView: 6,
                        spaceBetween: 24,
                    },
                    1536: {
                        slidesPerView: 10,
                        spaceBetween: 24,
                    },
                }}
                scrollbar={{ enabled: true, draggable: true, dragSize: 30 }}
                navigation={{
                    enabled: true,
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                loop
                autoplay={{
                    pauseOnMouseEnter: true,
                    delay: 1700,
                }}
                dir={i18n.dir.toString()}
                key={i18n.language + "categories"}
                className="rounded-[24px] bg-[rgba(207,219,211,1)] !px-3 !pb-16 !pt-3  xl:!px-8 xl:!pb-16 xl:!pt-8"
            >
                <div className="swiper-button-next !flex !size-12 !items-center !justify-center rounded-full bg-[rgba(255,255,255,0.4)] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] transition hover:bg-white">
                    <svg
                        width="12"
                        height="22"
                        viewBox="0 0 12 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="!h-[22px] !w-[12px]"
                    >
                        <path
                            d="M1.125 0.828125L0.1875 1.71875C0 1.95312 0 2.32812 0.1875 2.51562L8.67188 11L0.1875 19.5312C0 19.7188 0 20.0938 0.1875 20.3281L1.125 21.2188C1.35938 21.4531 1.6875 21.4531 1.92188 21.2188L11.7656 11.4219C11.9531 11.1875 11.9531 10.8594 11.7656 10.625L1.92188 0.828125C1.6875 0.59375 1.35938 0.59375 1.125 0.828125Z"
                            fill="#171717"
                        />
                    </svg>
                </div>
                <div className="swiper-button-prev !flex !size-12 !items-center !justify-center rounded-full bg-[rgba(255,255,255,0.4)] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] transition hover:bg-white">
                    <svg
                        viewBox="0 0 12 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="!h-[22px] !w-[12px]"
                    >
                        <path
                            d="M10.875 21.1719L11.8125 20.2812C12 20.0469 12 19.6719 11.8125 19.4844L3.32812 11L11.8125 2.46875C12 2.28125 12 1.90625 11.8125 1.67188L10.875 0.78125C10.6406 0.546875 10.3125 0.546875 10.0781 0.78125L0.234375 10.5781C0.046875 10.8125 0.046875 11.1406 0.234375 11.375L10.0781 21.1719C10.3125 21.4062 10.6406 21.4062 10.875 21.1719Z"
                            fill="#171717"
                        />
                    </svg>
                </div>
                {categories.map((category) => (
                    <SwiperSlide key={category.id}>
                        <Link
                            to={`/category/${category.id}`}
                            onClick={(e) =>
                                handleCategoryClick(e, category.name)
                            }
                            className="flex flex-col items-center"
                        >
                            <div className="mb-1 xl:mb-3">
                                <img
                                    src={category.image}
                                    alt={category.name}
                                    className="size-[118px] object-cover [clipPath:path('M_0_118_L_0,59_A_5,5_0,0,1_118,59_L_118_118_z')]"
                                />
                            </div>
                            <span className="text-center text-lg leading-tight text-[rgba(64,64,64,1)] xl:text-[22px]">
                                {category.name}
                            </span>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Modal or alert */}
            {showPopup && <Modal onClose={() => setShowPopup(false)} />}
        </div>
    );
}
